export default {
    option: ['All', 'Programmes', 'Exhibitor live'],
    status: {
        '1': 'Upcoming',
        '2': 'On live',
        '3': 'Replay'
    },
    startTime: 'Start time',
    looker: 'Replay',
    toLive: 'Enter',
    taggleLiveStatus: ['Live', 'Replay', 'Upcoming'],
    recommentLive: 'Recommendation',
    hotLive: 'Popularity',
    more: 'More',
    miss:"Interested",
    exchangeCards: "Exchange cards",
    success:"Success",
    successTips:"The request of exchange cards has sent",
    noData:"No data found",
    liveDescribe:'Live discription',
    'Live Management':'Live Management',
    sendDanMuTip:'Interact with the host',
    send:'Send',
    sendTextTip:'Please enter what was sent'
}